import {
    FANTACY_LOGIN,
    FANTACY_LOGIN_REDIRECT
} from './../../constants/actionTypes';

import {fantacyService} from "./services";

export const fantacyLogin = (username: string, password: string ) => {
    
    return dispatch => {
        dispatch(request({ username }));
        fantacyService.fantacyLogin(username, password);
    }
    function request(user) {
        return {type: FANTACY_LOGIN, user}
    }
    function success(user) {
        return {type: FANTACY_LOGIN_REDIRECT, payload: user}
    }
    function failure(error: string) {
        //return {type: LOGIN_USER_FAILED, payload: error}
    };
};